import { render, staticRenderFns } from "./TabProductsReservation.vue?vue&type=template&id=d8575560&"
import script from "./TabProductsReservation.vue?vue&type=script&lang=ts&"
export * from "./TabProductsReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d8575560', component.options)
    } else {
      api.reload('d8575560', component.options)
    }
    module.hot.accept("./TabProductsReservation.vue?vue&type=template&id=d8575560&", function () {
      api.rerender('d8575560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/NDV/TabsModals/Products/TabProductsReservation.vue"
export default component.exports